export default class extends HTMLElement {
  connectedCallback () {
    this.overlay = this.querySelector('[data-welcome-modal-target="overlay"]')
    this.skipBtn = this.querySelector('[data-welcome-modal-target="skipBtn"]')
    this.startBtn = this.querySelector('[data-welcome-modal-target="startBtn"]')

    this.skipBtn?.addEventListener('click', this.onSkip)
    this.startBtn?.addEventListener('click', this.onStartTour)
    this.overlay?.addEventListener('click', this.onOverlayClick)
  }

  disconnectedCallback () {
    this.skipBtn?.removeEventListener('click', this.onSkip)
    this.startBtn?.removeEventListener('click', this.onStartTour)
    this.overlay?.removeEventListener('click', this.onOverlayClick)
  }

  onSkip = () => {
    this.completeOnboarding()
  }

  onStartTour = () => {
    this.completeOnboarding().then(() => {
      // Find the tour element and start it directly
      const tourEl = document.querySelector('onboarding-tour')
      if (tourEl && typeof tourEl.start === 'function') {
        // Save step 1 first, then start the tour
        const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content || ''
        fetch('/user_configs', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-CSRF-Token': csrfToken
          },
          body: JSON.stringify({
            user_config: {
              key: 'onboarding_step',
              value: 1
            }
          })
        }).catch((err) => {
          console.error('Failed to save initial step:', err)
        })

        tourEl.setAttribute('data-start-step', '1')
        tourEl.start()
      }
    })
  }

  onOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      this.completeOnboarding()
    }
  }

  async completeOnboarding () {
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content || ''

    try {
      await fetch('/user_configs', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': csrfToken
        },
        body: JSON.stringify({
          user_config: {
            key: 'onboarding_completed',
            value: true
          }
        })
      })
    } catch (err) {
      // Silently fail — the modal should still close even if the API call fails
      console.error('Failed to save onboarding state:', err)
    }

    this.close()
  }

  close () {
    this.classList.add('hidden')
  }
}
